// ── DEMO MODE Finnish seed (temporary) ──────────────────────────────────────
// The demoed portal surfaces (messages, reports, pools, communication
// preferences, account, services, the principal switcher, nav) contain newer
// `<T _str="…"/>` strings that aren't in the tenant's remote Finnish Transifex
// resource yet, so they leak in English. For the all-Finnish PJH demo on
// renyy.wastehero.io we seed those Finnish translations directly into the
// Transifex native memory cache — no Transifex push/credentials needed, fully
// self-contained and revertible.
//
// Keyed by the SOURCE STRING (Transifex `generateKey` returns the source string
// verbatim when there's no _key/_context), so the cache lookup in
// tx.translateLocale finds them. cache.update() MERGES, so these sit on top of
// whatever the remote `fi` fetch already provided.
//
// MUST be called AFTER the remote `fi` fetch (see Company.store): seeding first
// would make the locale look non-stale and skip the remote fetch entirely,
// leaving everything else in English. Gated on isDemoMode() — a no-op otherwise.
import { tx } from '@transifex/native';
import { isDemoMode } from 'src/api/state';
import DEMO_FI from './demo-fi.json';

// Transifex locale code for Finnish (see LANGUAGES_MAP in src/components/I18n).
const FI_LOCALE = 'fi';

export const seedDemoFinnish = (): void => {
  if (!isDemoMode()) return;
  try {
    tx.cache.update(FI_LOCALE, DEMO_FI as Record<string, string>);
  } catch {
    /* cache unavailable — fall back to whatever the remote fetch provided */
  }
};
